module.exports = __webpack_public_path__ + "static/media/firm.f1e54a44.jpg";